import { useEffect, useState } from 'react';
import moment from 'moment';
import { getConsultantDailyContactsHistory } from '@/API/repositories/reports';
import { consultantHours } from '@/API/repositories/consultantHours';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';

export const useYourScore = () => {
	const [dailyContactsHistory, setDailyContactsHistory] = useState(null);
	const [hours, setHours] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const { makeRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const loadData = async () => {
		setIsLoading(true);

		const dailyContactsHistoryResponse = await makeRequest(
			getConsultantDailyContactsHistory.bind(null),
		);
		const hoursResponse = await makeRequest(consultantHours.bind(null));

		const hasContactsData = !!dailyContactsHistoryResponse?.data;
		const hasHoursData = !!hoursResponse?.data;

		if (!hasContactsData || !hasHoursData) {
			addMessage('Something went wrong', 'error');
			setIsLoading(false);
			return;
		}

		const todayHours = hoursResponse.data.data.find(
			(h) =>
				moment(h.for_day).format('YYYY-MM-DD') ===
				moment().startOf('day').format('YYYY-MM-DD'),
		);

		setDailyContactsHistory(dailyContactsHistoryResponse.data);
		setHours(
			todayHours?.attendance_at_work !== undefined
				? todayHours.attendance_at_work
				: 0,
		);
		setIsLoading(false);
	};

	useEffect(() => {
		loadData();
	}, []);

	return {
		dailyContactsHistory,
		hours,
		isLoading,
	};
};
